module.exports = __webpack_public_path__ + "img/oebb_infra_logo.59093022.jpg";